module.exports = __webpack_public_path__ + "img/d300x300.268f1e65.jpg";